function pitchUpdateCtrl(
  pitch,
  $uibModalInstance,
  $log,
  toastWrapperService,
  $translate
) {
  this.pitch = pitch;
  this.pitch.newStatus = this.pitch.currentStatus;
  this.availableStatuses = pitch.pitchStatuses;
  this.newNote = pitch.lastNote;

  this.close = () => {
    $uibModalInstance.dismiss();
  };

  this.submit = () => {
    this.pitch.save()
      .then((data) => {
        const pitchData = data;

        // temporary workaround to ensure display of the publication name without an API call
        if (pitch.publicationName) {
          pitchData.publicationName = pitch.publicationName;
        }

        $uibModalInstance.close(pitchData);
      }, (err) => {
        toastWrapperService.createToast($translate.instant('PITCH_UPDATE_FAILED'), 'danger');
        $log.error('pitchUpdateCtrl error: ', err);
      });
  };

  this.updateEdition = (update) => {
    this.pitch.newEditionTime = update.editionTime;
    this.pitch.sectionId = update.sectionId;
  };
}

const pitchUpdateCtrlArr = [
  'pitch',
  '$uibModalInstance',
  '$log',
  'toastWrapperService',
  '$translate',
  pitchUpdateCtrl
];

export default function (ngModule) {
  ngModule.controller('pitchUpdateCtrl', pitchUpdateCtrlArr);
}
